<style lang="scss">
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";

  .month-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: utils.in_rem(4px) 0;
    @include mixins.h4();
    @include colors.color(textBlack);
  }
</style>

<script>
  import IconButton from "../../atoms/IconButton.svelte";

  export let month;
  export let year;
  export let onPrevious = () => {};
  export let onNext = () => {};
  export let disablePrevious = false;
  export let disableNext = false;

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
</script>

<div class="month-header">
  <IconButton
    icon="fa-strong fa-chevron-left"
    onclick={onPrevious}
    disabled={disablePrevious}
    swHidden={disablePrevious}
  />

  {monthNames[month]}
  {year}

  <IconButton
    icon="fa-strong fa-chevron-right"
    onclick={onNext}
    disabled={disableNext}
    swHidden={disableNext}
  />
</div>
